import {
  Component,
  ComponentFactoryResolver,
  Input,
  OnInit,
  ViewContainerRef
} from '@angular/core';

import { ColorTypes }                     from '../../shared/types/color-types';
import { DynamicTableComponentComponent } from '../dynamic-table-component.component';
import { TableService }                   from '../table.service';

@Component({
  template: require('./badge-cell.component.html')
})

export class BadgeCellComponent extends DynamicTableComponentComponent implements OnInit {
  className : string;

  get data () : string {
    return this.tableService.formatCellData(this.record, this.column);
  }

  @Input() type: ColorTypes = 'primary';

  constructor (
    componentFactoryResolver: ComponentFactoryResolver,
    private tableService    : TableService,
    viewContainerRef        : ViewContainerRef
  ) {
    super(
      componentFactoryResolver,
      viewContainerRef
    );
  }

  ngOnInit () : void {
    this.className = `bg-${ this.type }`;
  }
}